import { Route, Routes, Navigate } from "react-router-dom"
import * as brands from "brands"
import * as layouts from "layouts"
import {
	MetricsContainer,
	MetricsApprovalsActiveLink,
	MetricsUploadsActiveLink,
	MetricsTrainingActiveLink,
	MetricsAssetTypesActiveLink,
	MetricsScoreFailuresActiveLink,
	MetricsModelAccuracyActiveLink,
	MetricsFeedbackTrendsActiveLink,
} from "./container"
import MetricsDisplayApproval from "./display.approval"
import MetricsDisplayUploads from "./display.uploads"
import MetricsDisplayTraining from "./display.training"
import MetricsDisplayAssetTypes from "./display.asset_types"
import MetricsDisplayScoreFailures from "./display.score_failures"
import MetricsDisplayModelAccuracy from "./display.model_accuracy"
import MetricsDisplayFeedbackTrends from "./display.feedback_trends"
import * as routing from "./routing"

export function MetricsApprovals(): JSX.Element {
	return (
		<MetricsContainer urlgen={routing.metrics_approvals}>
			<layouts.containers.flex flexDirection="column" height="100%" overflow="hidden" data-testid="metrics-approvals">
				<MetricsApprovalsActiveLink />
				<MetricsDisplayApproval />
			</layouts.containers.flex>
		</MetricsContainer>
	)
}

export function MetricsUploads(): JSX.Element {
	return (
		<MetricsContainer urlgen={routing.metrics_uploads}>
			<layouts.containers.flex flexDirection="column" height="100%" overflow="hidden" data-testid="metrics-uploads">
				<MetricsUploadsActiveLink />
				<MetricsDisplayUploads />
			</layouts.containers.flex>
		</MetricsContainer>
	)
}

export function MetricsTraining(): JSX.Element {
	return (
		<MetricsContainer urlgen={routing.metrics_training}>
			<layouts.containers.flex flexDirection="column" height="100%" overflow="hidden" data-testid="metrics-training">
				<MetricsTrainingActiveLink />
				<MetricsDisplayTraining />
			</layouts.containers.flex>
		</MetricsContainer>
	)
}

export function MetricsAssetTypes(): JSX.Element {
	return (
		<MetricsContainer urlgen={routing.metrics_asset_types}>
			<layouts.containers.flex flexDirection="column" height="100%" overflow="hidden" data-testid="metrics-asset-types">
				<MetricsAssetTypesActiveLink />
				<MetricsDisplayAssetTypes />
			</layouts.containers.flex>
		</MetricsContainer>
	)
}

export function MetricsScoreFailures(): JSX.Element {
	return (
		<MetricsContainer urlgen={routing.metrics_score_failures}>
			<layouts.containers.flex flexDirection="column" height="100%" overflow="hidden" data-testid="metrics-score-failures">
				<MetricsScoreFailuresActiveLink />
				<MetricsDisplayScoreFailures />
			</layouts.containers.flex>
		</MetricsContainer>
	)
}

export function MetricsModelAccuracy(): JSX.Element {
	return (
		<MetricsContainer urlgen={routing.metrics_model_accuracy}>
			<layouts.containers.flex flexDirection="column" height="100%" overflow="hidden" data-testid="metrics-model-accuracy">
				<MetricsModelAccuracyActiveLink />
				<MetricsDisplayModelAccuracy />
			</layouts.containers.flex>
		</MetricsContainer>
	)
}

export function MetricsFeedbackTrends(): JSX.Element {
	return (
		<MetricsContainer urlgen={routing.metrics_feedback_trends}>
			<layouts.containers.flex flexDirection="column" height="100%" overflow="hidden" data-testid="metrics-feedback-trends">
				<MetricsFeedbackTrendsActiveLink />
				<MetricsDisplayFeedbackTrends />
			</layouts.containers.flex>
		</MetricsContainer>
	)
}

export default function Routing(): JSX.Element {
	const brand = brands.caching.useCached()

	return (
		<layouts.backgrounds.Grey flex="0 1 100%" height="100%" overflowY="hidden">
			<Routes>
				<Route path="/approvals" element={<MetricsApprovals />} />
				<Route path="/uploads" element={<MetricsUploads />} />
				<Route path="/training" element={<MetricsTraining />} />
				<Route path="/asset-types" element={<MetricsAssetTypes />} />
				<Route path="/score-failures" element={<MetricsScoreFailures />} />
				<Route path="/model-accuracy" element={<MetricsModelAccuracy />} />
				<Route path="/feedback-trends" element={<MetricsFeedbackTrends />} />
				<Route path="*" element={<Navigate to={routing.metrics_approvals(brand.id)} replace />} />
			</Routes>
		</layouts.backgrounds.Grey>
	)
}
